import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useCareCoordinator } from '../care/CareCoordinatorContext';
import { HealthProfilePanel, TimelinePanel } from './care/CarePanels';
import './care/CarePanels.css';

function MonDossierSante() {
  const navigate = useNavigate();
  const {
    activeSubject,
    auditLog,
    healthProfileCompleteness,
    observations,
    recommendations,
    updateHealthProfile
  } = useCareCoordinator();

  return (
    <div style={{ maxWidth: 1180, margin: '0 auto', padding: '2rem 1rem 4rem', display: 'grid', gap: '1.5rem' }}>
      <section className="care-panel">
        <div className="care-panel__header">
          <div>
            <h3>Health record and profile hub</h3>
            <p>This care record now combines structured health profile data, observations, AI follow-up traceability, and future-ready care signals.</p>
          </div>
          <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap' }}>
            <button className="care-form__primary" type="button" onClick={() => navigate('/patient/rendez-vous')}>View appointments</button>
            <button className="care-form__secondary" type="button" onClick={() => navigate('/booking')}>Find care</button>
          </div>
        </div>
        <div className="care-pill-row">
          <span className="care-pill">{healthProfileCompleteness.percentage}% profile complete</span>
          <span className="care-pill">{observations.length} structured observations</span>
          <span className="care-pill">{recommendations.length} active suggestions</span>
        </div>
      </section>

      <HealthProfilePanel subject={activeSubject} completeness={healthProfileCompleteness} onSave={(values) => updateHealthProfile(activeSubject.id, values)} />
      <TimelinePanel observations={observations} auditLog={auditLog} />
    </div>
  );
}

export default MonDossierSante;
